var _dec, _class, _class2;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/** @jsx jsx */
import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import { IconAudioLine, IconAudioOffLine } from '@instructure/ui-icons';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { captionPositions } from '../../constants';
import { translate } from '../../constants/translated/translations';
import generateStyle from './styles';
/**
---
private: true
---
@module VolumeIndication
**/

let VolumeIndication = (_dec = withStyle(generateStyle, null), _dec(_class = (_class2 = class VolumeIndication extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      showNotification: false
    };
    this.timeoutRef = /*#__PURE__*/createRef();
  }

  componentDidMount() {
    const showNotification = this.state.showNotification;
    this.props.makeStyles({
      showNotification
    });
  }

  componentDidUpdate(_ref) {
    let prevTrigger = _ref.trigger;
    const trigger = this.props.trigger;
    const showNotification = this.state.showNotification;

    if (prevTrigger !== trigger) {
      clearTimeout(this.timeoutRef.current);
      this.setState({
        showNotification: true
      }, () => {
        this.timeoutRef.current = setTimeout(() => {
          this.setState({
            showNotification: false
          });
        }, 800);
      });
    }

    this.props.makeStyles({
      showNotification
    });
  }

  render() {
    const _this$props = this.props,
          styles = _this$props.styles,
          volume = _this$props.volume,
          trigger = _this$props.trigger;
    const Icon = volume !== 0 ? IconAudioLine : IconAudioOffLine;
    const percentVolume = Math.floor(volume * 100); // 0.55 becomes 55.0...1 after multiplication

    const text = `${translate('VOLUME_INDICATOR')} ${percentVolume}%`;
    const srLabel = (volume === 0 ? translate('VOLUME_MUTED') : text) + (trigger ? '.' : ''); // triggers SR for each notification (trigger)

    return jsx("div", {
      css: styles.container,
      role: "alert",
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "true"
    }, jsx(Icon, {
      size: "x-small"
    }), jsx(ScreenReaderContent, null, srLabel), jsx(PresentationContent, null, text));
  }

}, _class2.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  volume: PropTypes.number.isRequired,
  position: PropTypes.oneOf([captionPositions.TOP, captionPositions.BOTTOM]),
  trigger: PropTypes.bool.isRequired
}, _class2.defaultProps = {
  position: captionPositions.TOP
}, _class2)) || _class);
export default VolumeIndication;